/***
 * Created on 2023/7/17
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/


import React from 'react';
import TableHeaderField from "./table_header_field";

function TableHeader({fieldNameList, currentSortType, setCurrentSortType, sortDirection, setSortDirection}) {
    return (
        <div className="flex-table-header">
            {
                (fieldNameList || []).map(fieldName => (
                    <TableHeaderField
                        fieldName={fieldName.name}
                        size={fieldName.size}
                        sortable={fieldName.sortable}
                        isAction={fieldName?.isAction}
                        key={fieldName.id}
                        currentSortType={currentSortType}
                        setCurrentSortType={setCurrentSortType}
                        sortDirection={sortDirection}
                        setSortDirection={setSortDirection}/>
                ))
            }
        </div>
    );
}

export default TableHeader;